import { render, staticRenderFns } from "./OrderHall.vue?vue&type=template&id=d17ddb14&scoped=true"
import script from "./OrderHall.vue?vue&type=script&lang=js"
export * from "./OrderHall.vue?vue&type=script&lang=js"
import style0 from "./OrderHall.vue?vue&type=style&index=0&id=d17ddb14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17ddb14",
  null
  
)

export default component.exports